import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import OnboardingSteps from './components/tabs'
import OnboardingTabsContent from './components/tabs-content'
import { steps } from "./initiator";
import { useMutation, useQuery } from "@tanstack/react-query";
import AIOnboardingService from "../../../../apis/admin/AIOnboardingService"
import { toast } from "react-toastify";
import LoadingOnBoarding from "./components/loading";
import PageHeader from "src/modules/3rd-party-management/components/page-header";
import { useHistory } from "react-router-dom";
import CancelOnboardingModal from "./components/cancel-onboarding-modal";

const AIOnboardingPage = ({
    t
}) => {
    const history = useHistory();

    const [ tab, setTab ] = useState('requirements')
    const [ showCancelModal, setShowCancelModal ] = useState(false);

    const {
        data: proccessingStatusData,
        isFetching: statusIsFetching
    } = useQuery({
        queryKey: ['3rd-party-management-ai-onboarding-processing-status'],
        queryFn: async () => {
            const service = AIOnboardingService.getInstance();

            return await service.getCurrentStep();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching the current status of the operation.'), {
                type: 'error'
            });
        }
    });

    const cancelProcessMutation = useMutation({
        mutationFn: async () => {
            const service = AIOnboardingService.getInstance();
            return await service.cancelCurrentProcess();
        },
        onError: () => {
            toast(t("An error occurred while canceling process."), {
                type: "error"
            });
        },
        onSuccess: () => {
            history.push('/admin/3rd-party/manager');
        }
    });

    const handleGoToNextTab = useCallback(() => {
        const numberOfSteps = steps.length
        const currentStepIndex = steps.findIndex((step) => step.stepUniqueKey === tab)

        if (currentStepIndex < numberOfSteps - 1) {
            const nextStep = steps[currentStepIndex + 1]

            setTab(nextStep.stepUniqueKey)
        }
    }, [
        tab
    ]);

    const handleGoPrevTab = useCallback(() => {
        const currentStepIndex = steps.findIndex((step) => step.stepUniqueKey === tab)

        if(currentStepIndex > 0){
            const prevStep = steps[currentStepIndex - 1]

            setTab(prevStep.stepUniqueKey)
        }
    }, [
        tab
    ])
    
    const handleCancelProcess = useCallback(() => {
        setShowCancelModal(true);
    }, []);

    useEffect(() => {
        if(proccessingStatusData){
            let goToTab;
            switch(proccessingStatusData.status){
                case 'file_upload':
                case 'parse_master_file':
                        goToTab = 'confirmation'
                    break
                case 'start_process':
                    goToTab = 'processing'
                    break
                case 'start_product_process':
                    goToTab = 'processing_products'
                    break
                case 'done_process':
                    goToTab = 'processing_done'
                    break
                default:
                    // ready_to_start
                    goToTab = 'requirements'
            }
            setTab(goToTab)
        }
    }, [ proccessingStatusData ]);

    return (
        <div className='page-content ai-onboarding'>
            <Container fluid>
                <PageHeader 
                    title={t('Onboarding With AI')} 
                />
                <Row>
                    <Col sm='12'>
                        {statusIsFetching ? (
                            <LoadingOnBoarding />
                        ) : (
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm='12'>
                                            <OnboardingSteps 
                                                activeTab={tab}
                                            />
                                        </Col>
                                        <Col sm='12'>
                                            <OnboardingTabsContent 
                                                activeTab={tab}
                                                onNextButtonClicked={handleGoToNextTab}
                                                onBackButtonClicked={handleGoPrevTab}
                                                onCancelButtonClicked={handleCancelProcess}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Container>

            <CancelOnboardingModal 
                isOpen={showCancelModal}
                toggle={() => setShowCancelModal(false)}
                onConfirm={() => {
                    if (tab === 'requirements') {
                        history.push('/admin/3rd-party/manager');
                    }
                    else {
                        cancelProcessMutation.mutate();
                    }
                }}
                cancelationIsInProcess={cancelProcessMutation.isLoading}
            />
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    const { Organization } = state;
    return {
        user          :   state.Login.user,
        token         :   token,
        organization  :   Organization
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(AIOnboardingPage))
);